module.exports = __webpack_public_path__ + "static/ojebiyi-b26aeb45eb99acd34ca3600330d2da91.jpg";